import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { useEffect, useState } from "react"
import api from "../../../Axios"

export default function ManagePayments() {
  const [payments, setPayments] = useState([])
  const [filter, setFilter] = useState("all")

  // Fetch payment details
  const fetchPayments = async (filterValue) => {
    try {
      const endpoint =
        filterValue === "all" ? `${process.env.REACT_APP_BASE_URL}/api/v1/payment/all-payments` : `/api/v1/payments/filter?status=${filterValue}`
      const response = await api.get(endpoint)
      // Update to match your API structure
      setPayments(response.data.data)
    } catch (error) {
      console.error("Error fetching payments:", error)
      toast.error("Failed to fetch payment details.")
    }
  }

  // Fetch payments when component mounts or filter changes
  useEffect(() => {
    fetchPayments(filter)
  }, [filter, fetchPayments]) // Added fetchPayments to dependencies

  const handleDelete = async (payment) => {
    if (window.confirm("Are you sure you want to delete this payment?")) {
      try {
        await api.delete(`/api/v1/payments/delete/${payment._id}`)
        toast.success("Payment deleted successfully.")
        setPayments((prev) => prev.filter((p) => p._id !== payment._id))
      } catch (error) {
        console.error("Error deleting payment:", error)
        toast.error("Failed to delete payment.")
      }
    }
  }

  const getFeeTypeLabel = (feeType) => {
    switch (feeType) {
      case "degree":
        return "Degree Application"
      case "postage":
        return "Postage Charges"
      default:
        return "Other"
    }
  }

  return (
    <div className="min-h-screen p-4 bg-gray-100 sm:p-6 md:p-8 lg:p-12">
      <div className="container max-w-full mx-auto sm:max-w-7xl">
        <div className="p-4 mt-4 overflow-hidden bg-white border-2 border-teal-500 rounded-lg shadow-md sm:mt-8 sm:border-4">
          <h1 className="mb-4 text-2xl font-bold text-gray-900 sm:mb-6 sm:text-3xl">Payment Management</h1>
          <div className="-mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Payment ID
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Roll Number
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Batch
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Course
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Fee Type
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Amount
                      </th>
                      <th
                        scope="col"
                        className="px-4 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase sm:px-6"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {Array.isArray(payments) &&
                      payments.map((payment) => (
                        <tr key={payment._id}>
                          <td className="px-4 py-3 text-sm font-medium text-gray-900 sm:px-6 whitespace-nowrap">
                            {payment._id}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">{payment.name}</td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">
                            {payment.rollNumber}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">{payment.batch}</td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">
                            {payment.course}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">
                            {getFeeTypeLabel(payment.feeType)}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500 sm:px-6 whitespace-nowrap">
                            ₹{Math.max(0, payment.amount).toFixed(2)}
                          </td>
                          <td className="px-4 py-3 sm:px-6 whitespace-nowrap">
                            <span
                              className={`px-2 py-1 text-xs font-semibold rounded-full ${
                                payment.paymentStatus === "Completed"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-yellow-100 text-yellow-800"
                              }`}
                            >
                              {payment.paymentStatus}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

